import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import Axios from 'axios';
import Header from './modules/Common/Header';
import Dashboard from './modules/Common/Dashboard';
import Requester from './modules/Requester';
import Ops from './modules/Ops';
import OtpLogin from './modules/Common/OtpLogin';
import Vendor from './modules/Vendor';
import Admin from './modules/Admin';
import { clearAndHandleLogout, getLocalActiveRole, updateTokenForPersistnce } from './utils/authUtils';
import { canUserRoleAccessRoute, setLocalActiveRole } from './utils/authUtils';
import AuthCallback from './modules/AuthCallback';
import Trigger3DModelByGLB from './modules/Common/Trigger3DModelByGLB';
import PreviewFSNModels from './modules/Common/PreviewFSNModels';
import GoLive from './modules/Ops/GoLive';
import { Routes } from './utils/constants/routes';
import { useAuthStore } from './stores/authStore';
import { useEffect } from 'react';
import { getUserProfile } from './utils/api/userApi';
import FullScreenLoadingScreen from './components/common/FullScreenLoadingScreen';
import { Roles } from './utils/enums';

Axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL_DEV_LOCAL;
Axios.defaults.headers.common['Authorization'] = localStorage.getItem('token');

const authToken = localStorage.getItem('token');
if (authToken) updateTokenForPersistnce(authToken);

const PrivateRoute = (props: any) => {
    const { component: IncomingComponent, location, computedMatch, ...remainingProps } = props;
    const { pathname, search } = location;

    const authenticated = useAuthStore((state) => state.authenticated);
    const allowedRoutesForUser = useAuthStore((state) => state.allowedRoutesForUser);

    /** Check for token again in localStorage */
    const token = localStorage.getItem('token');
    if (!token) return <Redirect to={Routes.LOGIN} />;
    // if (!authenticated) {
    //     // await make getProfile api call and set context
    // }
    if (authenticated && canUserRoleAccessRoute(allowedRoutesForUser, pathname)) {
        return <Route {...remainingProps} component={IncomingComponent} />;
    }
    return <Route {...remainingProps} component={IncomingComponent} />;
    // return (
    //   <Redirect
    //     to={`/auth/callback?token=${token}&redirect=${pathname}${search}`}
    //   />
    // );
};

const App = () => {
    const setUserDetails = useAuthStore((state) => state.setUserDetails);
    const setActiveRole = useAuthStore((state) => state.setActiveRole);
    const setActivePartner = useAuthStore((state) => state.setActivePartner);

    const handleGetUser = async () => {
        try {
            if (authToken) {
                const resp = await getUserProfile();
                setUserDetails(resp.data);
                const partner = resp.data.org || 'partner';
                setActivePartner(partner);
                const localActiveRole = getLocalActiveRole();
                const rolesName: any = [];
                if (localActiveRole === null) {
                    for (let i = 0; i < resp.data.roles.length; i++) {
                        const element = resp.data.roles[i];
                        rolesName.push(element.name);
                    }

                    if (rolesName.include(Roles.ADMIN)) {
                        setActiveRole(Roles.ADMIN);
                        setLocalActiveRole(Roles.ADMIN);
                    } else if (rolesName.include(Roles.REQUESTOR)) {
                        setActiveRole(Roles.REQUESTOR);
                        setLocalActiveRole(Roles.REQUESTOR);
                    } else if (rolesName.length) {
                        setActiveRole(rolesName[0]);
                        setLocalActiveRole(rolesName[0]);
                    }
                } else {
                    setActiveRole(Roles[localActiveRole]);
                }
            }
        } catch {
            clearAndHandleLogout();
        }
    };

    useEffect(() => {
        handleGetUser();
    }, []);

    return (
        <Router basename={process.env.REACT_APP_APP_BASENAME}>
            <FullScreenLoadingScreen />
            <Header />
            <Switch>
                <PrivateRoute path={Routes.REQUESTER_ROUTES.ROOT}>
                    <Trigger3DModelByGLB />
                </PrivateRoute>
                <PrivateRoute path={Routes.OPS_ROUTES.ROOT}>
                    <Trigger3DModelByGLB />
                </PrivateRoute>
                <PrivateRoute path={Routes.VENDOR_ROUTES.ROOT}>
                    <Vendor />
                </PrivateRoute>
                <PrivateRoute path={Routes.ADMIN_ROUTES.ROOT}>
                    <Trigger3DModelByGLB />
                </PrivateRoute>
                <PrivateRoute path={Routes.SEARCH_BY_GLB}>
                    <Trigger3DModelByGLB />
                </PrivateRoute>
                <PrivateRoute path={Routes.PREVIEW}>
                    <PreviewFSNModels />
                </PrivateRoute>
                <PrivateRoute path={Routes.GOLIVE}>
                    <GoLive />
                </PrivateRoute>
                <Route exact path={Routes.LOGIN} component={OtpLogin} />
                <Route exact path={Routes.AUTH_CALLBACK} component={AuthCallback} />
                <PrivateRoute exact path={Routes.ROOT}>
                    <Dashboard />
                </PrivateRoute>
                <PrivateRoute path={Routes.INDEX}>
                    <Dashboard />
                </PrivateRoute>
            </Switch>
        </Router>
    );
};

export default App;
